import { useEffect } from 'preact/hooks';
import { useSignal } from '@preact/signals';

// Rotate through these labels while tools are running
const THINKING_LABELS = [
  'Thinking…',
  'Looking up…',
  'Calling service…',
  'Fetching data…',
  'Processing…',
  'Analysing…',
  'Checking…',
  'Retrieving…',
];

export function ToolCallIndicator({ toolCalls }) {
  if (!toolCalls?.length) return null;

  const anyPending = toolCalls.some(t => !t.done && !t.error);
  const anyError   = toolCalls.some(t => t.error);

  // Cycle through label words every 1.8 s while tools are running
  const labelIdx = useSignal(0);
  useEffect(() => {
    if (!anyPending) return;
    const iv = setInterval(() => {
      labelIdx.value = (labelIdx.value + 1) % THINKING_LABELS.length;
    }, 1800);
    return () => clearInterval(iv);
  }, [anyPending]);

  // Once all tools are done (or errored), render nothing — the answer takes over
  if (!anyPending && !anyError) return null;

  if (anyError && !anyPending) {
    return (
      <div class="mc-thinking" role="status">
        <span class="mc-thinking-dot mc-thinking-dot-err" aria-hidden="true" />
        <span class="mc-thinking-label">Could not complete action</span>
      </div>
    );
  }

  return (
    <div class="mc-thinking" role="status" aria-live="polite">
      <span class="mc-thinking-spin" aria-hidden="true" />
      <span class="mc-thinking-label">{THINKING_LABELS[labelIdx.value]}</span>
    </div>
  );
}
